import * as THREE from 'three';
import { Twist, Vec3 } from "../../../../models/SyntheticMap";
import { copyVec3, toVector3, vectorFromParentToChildLocal } from '../../../../visuals/visual-utils';
import { constrain } from '../../../../utils/spatial';


export abstract class DragonflyController {
  public static PITCH_VERT = Math.PI / 2;
  public static PITCH_NORM = 0;
  public frameReference!: THREE.Object3D;
  public objectReference!: THREE.Object3D;
  public craft!: THREE.Object3D;

  abstract computeTwist(dt: number): Twist | DragonflyController | string;

  public getPropSpeed(): number {
    return 20.0; // Default implementation, can be overridden
  }
  public visualization(on: boolean): void { }
  public getStatus(): string {
    return "Navigating";
  }

  public modulate(v: number, min: number, max: number, epsilon: number) {
    const a = Math.abs(v);
    if (a < epsilon) {
      return 0;
    }
    const sign = v / a;
    const m = constrain(a, min, max);
    return m * sign;
  }

  public modulateCorrection(v: Vec3, gain: number, min: number, max: number, epsilon: number) {
    return {
      x: this.modulate(v.x * gain, min, max, epsilon),
      y: this.modulate(v.y * gain, min, max, epsilon),
      z: this.modulate(v.z * gain, min, max, epsilon)
    }
  }

  public refToLocal(pos: Vec3) {
    const v = new THREE.Vector3();
    copyVec3(pos, v);
    return vectorFromParentToChildLocal(this.frameReference, this.objectReference, v);
  }

  public refToCraft(pos: Vec3) {
    const v = new THREE.Vector3();
    copyVec3(pos, v);
    return vectorFromParentToChildLocal(this.frameReference, this.craft, v);
  }


  public getOverPoint(pos: Vec3) {
    const op = this.objectReference.position.clone();
    const pv = toVector3(pos);

  }
}
